export default {
  knowListData: {},
  knowTreeData: [],
  detail: {},
  knowTeam: [],
  transferDetail: {},
  clueVisit: {},
};
